import { ArrowUp, ArrowDown, Eye, EyeOff, Pencil, Trash2 } from "lucide-react";
import { SCHEMAS } from "@/lib/sections";

export const SectionRow = ({ section, index, total, onMove, onToggle, onEdit, onDelete }) => {
  const schema = SCHEMAS[section.type];
  const preview = section.content?.title || section.content?.title_es || "";
  return (
    <li
      className={`flex items-center gap-3 rounded-xl border px-4 py-3 transition-colors duration-200 ${section.visible ? "border-slate-800 bg-slate-900/60" : "border-dashed border-slate-800 bg-slate-950 opacity-60"}`}
      data-testid={`section-row-${section.type}-${index}`}
    >
      <span className="w-6 font-mono text-xs text-slate-600">{String(index + 1).padStart(2, "0")}</span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-white">{schema?.label || section.type}</p>
        <p className="truncate font-mono text-[11px] text-slate-500">
          {section.builtin ? "original" : "nueva"}{preview ? ` · ${preview.replace(/\*/g, "")}` : ""}
        </p>
      </div>
      <div className="flex items-center gap-1">
        <button disabled={index === 0} onClick={() => onMove(index, -1)} className="admin-icon-btn" aria-label="Subir" data-testid={`section-up-${index}`}><ArrowUp size={15} /></button>
        <button disabled={index === total - 1} onClick={() => onMove(index, 1)} className="admin-icon-btn" aria-label="Bajar" data-testid={`section-down-${index}`}><ArrowDown size={15} /></button>
        <button onClick={() => onToggle(section)} className="admin-icon-btn" aria-label={section.visible ? "Ocultar" : "Mostrar"} data-testid={`section-toggle-${index}`}>
          {section.visible ? <Eye size={15} /> : <EyeOff size={15} />}
        </button>
        <button onClick={() => onEdit(section)} className="admin-icon-btn hover:text-sky-400" aria-label="Editar" data-testid={`section-edit-${index}`}><Pencil size={15} /></button>
        {!section.builtin && (
          <button onClick={() => onDelete(section)} className="ml-1 inline-flex items-center gap-1 rounded-md border border-red-500/30 px-2 py-1 text-xs text-red-400 transition-colors duration-200 hover:bg-red-500/10" aria-label="Eliminar" data-testid={`section-delete-${index}`}><Trash2 size={13} /> Borrar</button>
        )}
      </div>
    </li>
  );
};

export default SectionRow;
